import { Step } from 'signup-constants/Step';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
import { setFlow } from '../../store/flow/action-creators';
export const BranchACQ0177VariantA = {
  name: 'BranchACQ0177VariantA',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0177, [ExperimentParameterGroup.Variant_A]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    const {
      preVerification,
      postExistingAccountSelection,
      postAccountCreation
    } = getFlowSteps();
    const postVerificationSteps = [Step.Password, Step.Name, Step.LoadingPage, Step.ManagementLevel, Step.CompanyDomain, Step.Industry, Step.CompanySize, Step.CompanyName, Step.Review];
    const nextSteps = [...(isPreVerification() ? preVerification : []), ...postVerificationSteps, ...postAccountCreation];
    dispatch(setFlow(nextSteps, preVerification, postVerificationSteps, postAccountCreation, postExistingAccountSelection));
    return nextSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};